import { Box, Typography, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import theme from '../../theme';
import { WorkItemWithType } from '../../types/workPackages';

type MaterialDataGridProps = {
  rows: WorkItemWithType[];
  columns: GridColDef<WorkItemWithType>[];
  title?: string;
  isEditable?: boolean;
  handleServiceModal: (id?: number | undefined) => void;
  handleMaterialModal: (id?: number | undefined) => void;
  showType: boolean;
};

const commonDataGridStyles = {
  height: 300,
  width: '100%',
  '.MuiDataGrid-columnHeaders': {
    backgroundColor: '#fafafa',
    fontSize: '13px',
  },
  '.MuiDataGrid-row:last-child': {
    borderBottom: 'none',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '.MuiDataGrid-cell': {
    fontSize: '13px',
    textTransform: 'capitalize',
  },
  '.MuiDataGrid-row:hover': {
    cursor: 'pointer',
    backgroundColor: '#f0f4f7',
  },
};

const MaterialDataGrid = observer(
  ({
    rows,
    columns,
    title,
    isEditable,
    handleServiceModal,
    handleMaterialModal,
    showType,
  }: MaterialDataGridProps) => {
    const { t } = useTranslation();

    return (
      <Box>
        {title && (
          <Box
            sx={{
              backgroundColor: '#f5f5f5',
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, fontSize: '0.875rem' }}
            >
              {title}
            </Typography>
            {isEditable && (
              <Box>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleServiceModal()}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: 'white',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                    marginRight: '10px',
                  }}
                >
                  {t('service.service')}
                </Button>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleMaterialModal()}
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: 'white',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  }}
                >
                  {t('material.material')}
                </Button>
              </Box>
            )}
          </Box>
        )}
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          columnVisibilityModel={{ type: showType }}
          hideFooter
          disableRowSelectionOnClick
          sx={commonDataGridStyles}
          onRowClick={params => {
            if (params.row.type === 'service') {
              handleServiceModal(params.row.id);
            } else if (params.row.type === 'material') {
              handleMaterialModal(params.row.id);
            }
          }}
        />
      </Box>
    );
  },
);

export default MaterialDataGrid;
